export default __webpack_public_path__ + "static/media/STLBMIntimation07082025.585ec426.pdf";